// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"78":"c56803d9f6278853","988":"f4d61a88b8ffcb44"}[chunkId] + ".js";
};